import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetEmployeeLeave } from "widgets/src/WidgetEmployeeLeave/WidgetEmployeeLeave";
import { WidgetEmployeeLeavePreviewQuery } from "./__generated__/WidgetEmployeeLeavePreviewQuery.graphql";

type Props = {
  storecastId: string;
  query: PreloadedQuery<WidgetEmployeeLeavePreviewQuery>;
};

export const WIDGET_EMPLOYEE_LEAVE_PREVIEW_QUERY = graphql`
  query WidgetEmployeeLeavePreviewQuery(
    $input: PreviewWidgetEmployeeLeaveInput!
    $storecastId: ID!
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetEmployeeLeave(input: $input) {
        ...WidgetEmployeeLeave_widgetEmployeeLeave
      }
    }
  }
`;
export function WidgetEmployeeLeavePreview(props: Props) {
  const data = usePreloadedQuery<WidgetEmployeeLeavePreviewQuery>(
    WIDGET_EMPLOYEE_LEAVE_PREVIEW_QUERY,
    props.query
  );

  if (!data.dashboard.previewWidgetEmployeeLeave) {
    return null;
  }
  return (
    <WidgetEmployeeLeave
      interactive={false}
      widget={data.dashboard.previewWidgetEmployeeLeave}
      mode="IDLE"
      storecastId={props.storecastId}
    />
  );
}
